//src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { configureStore } from "@reduxjs/toolkit";
import App from "./App";
import rootreducer from "./slices";
import { baseApi } from "./redux/services/baseApi";

// ✅ Guest cart key (stable across refresh)
const GUEST_KEY = "guest_session_key";
if (!localStorage.getItem(GUEST_KEY)) {
  const v =
    (window.crypto as any)?.randomUUID?.() ??
    `g_${Date.now()}_${Math.random().toString(16).slice(2)}`;
  localStorage.setItem(GUEST_KEY, v);
}

const store = configureStore({
  reducer: rootreducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);

reportWebVitals();